<div class="header-container">
  <div>
    <mat-form-field class="filter-form-field">
      <mat-label>Search for a national drug by brand name</mat-label>
      <input #nationalDrugSearch matInput type="text" [formControl]="nationalDrugFormControl"
             data-qa="qa-input"
             (input)="onInputChangedFilterData('brandName')">
    </mat-form-field>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button [routerLink]="'/pharmacy-management/add-national-drug'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon>
      Add National Drug
    </button>
  </div>
</div>

<div *ngIf="!nationalDrugDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="nationalDrugDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="nationalDrugDataSource" #nationalDrugSort="matSort"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editNationalDrugTooltip="matTooltip"
                  matTooltip="EDIT National Drug" (click)="editEntry($event, row.nationalDrugId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteNationalDrugTooltip="matTooltip"
                  matTooltip="DELETE National Drug" (click)="deleteEntry($event, row.nationalDrugId)">
          delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="nationalDrugId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.nationalDrugId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="nationalDrugCode">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> National Drug Code</th>
      <td *matCellDef="let row" mat-cell> {{row.nationalDrugCode}}</td>
    </ng-container>
    
    <ng-container matColumnDef="brandName">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Brand Name</th>
      <td *matCellDef="let row" mat-cell> {{row.brandName | slice:0:25}}</td>
    </ng-container>
    
    <ng-container matColumnDef="masterDrug">
      <th *matHeaderCellDef mat-header-cell> Master Drug Name</th>
      <td *matCellDef="let row" mat-cell> {{row.masterDrug.name | slice:0:50}}</td>
    </ng-container>
    
    <ng-container matColumnDef="registrationOwner">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Registration Owner</th>
      <td *matCellDef="let row" mat-cell> {{row.registrationOwner}}</td>
    </ng-container>
    
    <ng-container matColumnDef="referenceName">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Origin Reference</th>
      <td *matCellDef="let row" mat-cell> {{row.referenceName}}</td>
    </ng-container>
    
    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell> End Date</th>
      <td *matCellDef="let row" mat-cell> {{row.endDate | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="nationalDrugDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == nationalDrugExpandedRow ? 'expanded' : 'collapsed'">
          <b>Drug Name: </b>{{row.drugName}}<br>
          <b>Regulator: </b>{{row.regulator.name}}<br>
          <b>Manufacturer: </b>{{displayObjectNameIfNotNull(row.manufacturer)}}<br>
          <b>Dosage form: </b>{{row.dosageForm.name}}<br>
          <b>Country: </b>{{row.country}}<br>
          <b>Currency: </b>{{row.currency.name}}<br>
          <b>Pack Price: </b>{{row.packPrice}}<br>
          <b>Each Price: </b>{{row.eachPrice}}<br>
          <b>Status: </b>{{row.status.name}}<br>
          <b>Start date: </b>{{row.startDate | date: dateFormat}}<br>
          <b>Approval Reference: </b>{{row.approvalReference}}<br>
          <b>Approval Date: </b>{{row.approvalDate | date: dateFormat}}<br>
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="nationalDrugDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: nationalDrugDisplayedColumns;" class="row"
        [class.expanded-row]="nationalDrugExpandedRow == row"
        (click)="nationalDrugExpandedRow = nationalDrugExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #nationalDrugPaginator (page)="pageChanged($event)"
                 [length]="nationalDrugTableControl.length" [pageSize]="nationalDrugTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="nationalDrugTableControl.pageSizeOptions">
  </mat-paginator>

</div>
